<template>
  <section class="s-strip s-destinations">
    <div class="page-container">
      <Loader v-if="isLoading"></Loader>
      <Alert
        v-if="errorMsgs.length"
        type="danger"
        :messages="errorMsgs"></Alert>

      <div class="s-destinations__header">
        <div class="row align-items-center">
          <div class="col-lg-5">
            <h2 class="s-destinations__header-title">{{ title }}</h2>
          </div>

          <div v-if="hasSorting" class="col-lg-4 mb-40 mb-lg-0">
            <div class="b-dropdown-sort">
              <div class="semibold b-dropdown-sort__label">
                {{ dictionary.sortLabel }}
              </div>
              <div class="b-dropdown-sort__menu">
                <select
                  v-model="sort"
                  class="form-select"
                  @change="onChangeSort">
                  <option
                    v-for="item in sortOptions"
                    :key="item.value"
                    :value="item.value">
                    {{ item.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div
            class="col-lg-3"
            :class="{ 'col-lg-3 offset-lg-4': !hasSorting }">
            <div class="input-group">
              <input
                id="searchTerm"
                ref="searchTerm"
                v-model.trim="searchTerm"
                v-debounce="fetchData"
                class="form-control form-control-search"
                name="searchTerm"
                :placeholder="dictionary.searchTermPlaceholder"
                type="search" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-container">
      <div class="s-destinations__body">
        <div v-auto-animate class="s-destinations__grid">
          <!-- b-block for each destination nside our grid -->
          <div
            v-for="item in records"
            :key="item.id"
            class="s-destinations__item">
            <Destination :item="item" />
          </div>
        </div>

        <div v-if="!records.length">
          <NoResults></NoResults>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import jQuery from 'jquery'
import axios from 'axios'
import * as lib from '../../lib/lib'
import Destination from './../components/Destination.vue'
import constants from './../../lib/constants'
/* eslint-disable no-unused-vars */
import { forEach, sortBy } from 'lodash'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'
import NoResults from './../components/common/NoResults.vue'
import { vue3Debounce } from 'vue-debounce'

export default {
  components: { Destination, Alert, Loader, NoResults },
  directives: {
    debounce: vue3Debounce({ lock: true, defaultTime: '800ms' }),
  },
  data() {
    return {
      isLoading: false,
      errorMsgs: [],
      title: '',
      records: [],
      sort: '',
      // data sources
      sortOptions: [],
      searchTerm: '',
    }
  },
  computed: {
    hasSorting() {
      return this.sortOptions?.length > 1
    },
  },
  mounted() {
    const { title, sortOptions } = lib.getData('destinationsData')
    this.title = title
    this.sortOptions = sortOptions

    this.setPreselectedOptions()
    this.fetchData()

    // search clear event
    jQuery('#searchTerm').on('search', (evt) => {
      if (!this.searchTerm) {
        this.fetchData()
      }
    })
  },
  methods: {
    addOriginalIndex() {
      /* eslint-disable no-undef */
      _.forEach(this.records, (x, index) => {
        x.originalIndex = index
      })
    },

    setPreselectedOptions() {
      // sort
      const entry = this.sortOptions.find((i) => i.selected)
      if (entry) {
        this.sort = entry.value
        this.onChangeSort()
      }
    },

    onChangeSort() {
      const { alpha, featured } = constants.sort

      switch (this.sort) {
        case alpha:
          this.records = _.sortBy(this.records, (x) => x.alphaOrder)
          break
        case featured:
          this.records = _.sortBy(this.records, (x) => x.originalIndex)
          break
        default:
          this.records = _.sortBy(this.records, (x) => x.originalIndex)
      }
    },

    fetchData() {
      this.isLoading = true

      const postData = {
        searchTerm: this.searchTerm,
      }

      axios
        .post(this.configuration.endpointFetchData, postData)
        .then((response) => {
          const { hasError, errorMessages, data } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          const { records } = data
          this.records = records
          this.addOriginalIndex()
          this.onChangeSort()

          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
      this.$nextTick(() => {
        lib.scrollToError(300)
      })
    },
  },
}
</script>
